export default {
    columns: [
        {
            label: '分公司',
            value: 'companyName',
            width: '120px'
        },
        {
            label: '服务平台',
            value: 'siteName',
            width: '140px'
        },
        {
            label: '客户订单号',
            value: 'customerOrderNo',
            width: '200px'
        },
        {
            label: '运输单号',
            value: 'taskNo',
            width: '160px'
        },
        {
            label: '方数(m³)',
            value: 'totalVolume',
            width: '100px'
        },
        {
            label: '线路里程(km)',
            value: 'mileage',
            width: '100px'
        },
        {
            label: '是否限行',
            value: 'restrictFlagName',
            width: '100px'
        },
        {
            label: '运输单状态',
            value: 'taskStatusName',
            width: '100px'
        },
        {
            label: '目的区县',
            value: 'receiverDistrictName',
            width: '140px'
        },
        {
            label: '目的乡镇',
            value: 'receiverTownName',
            width: '140px'
        },
        {
            label: '详细地址',
            value: 'receiverDetailAddr',
            width: '260px'
        },
        {
            label: '收货人',
            value: 'receiverName',
            width: '140px'
        },
        {
            label: '收货人联系方式',
            value: 'receiverMobile',
            width: '140px'
        },
        {
            label: '装货仓库',
            value: 'whName',
            width: '140px'
        },
        {
            label: '商品分类',
            value: 'itemClassName',
            width: '140px'
        }
    ]
};
